module.exports = __webpack_public_path__ + "static/media/production ID_4694341.77136e77.mp4";